export default "__VITE_ASSET__4bee3256__"